import React from 'react';
import './App.css';
import Results from "./components/Main/Results";
import Header from "./components/Header";


function App() {
  return (
    <>
      <Header />
      <Results />

    </>
  );
}

export default App;
